import React, { Component } from "react";

import MarkdownPage from "../utils/MarkdownPage";

export default class ImpressumMd extends Component {
  render() {
    return <MarkdownPage uri="/datenschutz/web.md?1" />;
  }
}
